import React, { useState } from 'react';
import emailjs from 'emailjs-com';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Remplacez ces valeurs par vos identifiants EmailJS réels.
    const serviceID = "service_55v7tto";
    const templateID = "template_s8jyw3f";
    const userID = "7GAjDVpnRRb5pQNO2";

    emailjs.send(serviceID, templateID, formData, userID)
      .then((result) => {
          console.log(result.text);
          setPopupMessage("Votre message a été envoyé avec succès.");
          setPopupVisible(true);
          // Réinitialiser le formulaire
          setFormData({
            name: "",
            email: "",
            subject: "",
            message: ""
          });
      }, (error) => {
          console.log(error.text);
          setPopupMessage("Une erreur est survenue lors de l'envoi. Veuillez réessayer.");
          setPopupVisible(true);
      });
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Section Contact à gauche */}
        <div className="contact-section">
          <h1>Contact</h1>
          <p>
            Nous sommes à votre écoute pour toute demande d'information sur nos formations agricoles.
          </p>
          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="name">Nom / Prénom</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Votre nom"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <label htmlFor="email">Adresse e-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="exemple@domaine.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label htmlFor="subject">Sujet</label>
            <input
              type="text"
              id="subject"
              name="subject"
              placeholder="Sujet de votre message"
              value={formData.subject}
              onChange={handleChange}
              required
            />
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Votre message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit" className="btn">Envoyer</button>
          </form>
        </div>

        {/* Section Logo à droite */}
        <div className="logo-section">
          <img src="/logo-wayagri.png" alt="Way-Agri Logo" className="big-logo" />
        </div>
      </div>

      {/* Popup centré */}
      {popupVisible && (
        <div className="popup">
          <p>{popupMessage}</p>
          <button className="btn-popup" onClick={() => setPopupVisible(false)}>
            OK
          </button>
        </div>
      )}
    </div>
  );
}

export default ContactPage;
